import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@siat-fe/env';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RolesService {
  private readonly baseUrl = environment.baseUrl;
  private httpClient = inject(HttpClient);

  fetchGetAllRoles(type: string): Observable<never[]> {
    const reqUrl = `${this.baseUrl}v1/tipology/findAll/${type}`;
    return this.httpClient.get<never[]>(reqUrl);
  }

  fetchGetAllStrutture(): Observable<never[]> {
    const reqUrl = `${this.baseUrl}v1/findStrutturaAssociation`;
    return this.httpClient.get<never[]>(reqUrl);
  }
}
